import { EventStatus } from './types';

import type { StatusType } from '@kc-console/common-ui';
import type { EventStatusType } from './types';

/**
 * 이벤트 상태 라벨 맵을 반환한다.
 * @description
 * - 상태값에 대응되는 한국어 라벨을 제공한다.
 * @example
 * const label = getEventStatusLabelMap()[EventStatus.Opened];
 */
export const getEventStatusLabelMap = (): Record<EventStatusType, string> => ({
  [EventStatus.Opened]: '확인 필요',
  [EventStatus.Processing]: '처리 중',
  [EventStatus.Resolved]: '해결됨',
});

/**
 * 이벤트 상태를 `Status` 컴포넌트의 `status` 타입으로 매핑한다.
 * @description
 * - Opened → warning, Processing → error, Resolved → active
 * @example
 * const variant = getEventStatusVariant(EventStatus.Opened);
 */
export const getEventStatusVariant = (status: EventStatusType): StatusType => {
  switch (status) {
    case EventStatus.Opened:
      return 'warning';
    case EventStatus.Processing:
      return 'error';
    case EventStatus.Resolved:
      return 'active';
    default:
      return 'inactive';
  }
};
